module.exports = __webpack_public_path__ + "images/leksaker.c85fb234.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/EbaySweden.TouchWeb/static/images/category-carousel/leksaker.jpg
// module id = 0e584b66
// module chunks = 10 37